import "./StartYourJourney.module.css";
import Header from "@/reusable_sections/Header";
import StartYourJourney from "./sections/StartYourJourney";
import CommonInquiries from "./sections/CommonInquiries";
import Footer from "@/reusable_sections/Footer";
export default function StartYourJourneyPage() {
  return <div>
      <Header />
      <StartYourJourney />
      <CommonInquiries />
      <Footer />
    </div>;
}